import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  productTypeContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
  },
  textHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.labraCheckbox.main,
  },
  sectionHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  sectionText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    width: '100%',
  },
  sectionHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  companyDetailsContainer: {
    display: 'flex',
    gap: '24px',
    width: '100%',
  },
  inputWidth: {
    width: '50%',
  },
  boxWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(3),
  },
}))
